import { createContext, type PropsWithChildren, useEffect, useState } from 'react'

import { AffectedStaffMap } from '../types/models/affectedStaff/affected-staff'

type AffectedStaffContextType = {
  affectedStaff: AffectedStaffMap['FULL'] | null
  setAffectedStaff: (s: AffectedStaffMap['FULL'] | null) => void
}

export const AffectedStaffContext = createContext<AffectedStaffContextType>({
  affectedStaff: null,
  setAffectedStaff: () => {}
})

type Props = {
  affectedStaff: AffectedStaffMap['FULL']
}

const AffectedStaffProvider = ({ children, affectedStaff }: PropsWithChildren<Props>) => {
  const [state, setState] = useState<AffectedStaffMap['FULL'] | null>(affectedStaff ?? null)

  useEffect(() => {
    setState(affectedStaff ?? null)
  }, [affectedStaff])

  return (
    <AffectedStaffContext.Provider value={{ affectedStaff: state, setAffectedStaff: setState }}>
      {children}
    </AffectedStaffContext.Provider>
  )
}

export default AffectedStaffProvider
